module.exports = __webpack_public_path__ + "media/home/new-york-times-a7c93d6d.png";